<template>
    <div>
      <!-- 🔧 Catálogo de variables -->
      <div class="mb-2 flex flex-wrap gap-2">
        <span class="text-sm font-medium">Variables disponibles:</span>
        <button 
          v-for="variable in variablesDisponibles" 
          :key="variable.clave" 
          @click="insertarVariable(variable.clave)"
          class="bg-gray-200 text-sm px-2 py-1 rounded hover:bg-gray-300"
        >
          {{ variable.clave }}
        </button>
      </div>
  
      <!-- Editor -->
      <QuillEditor 
        v-model:content="content" 
        contentType="html" 
        theme="snow"
        ref="quillRef"
        style="height: 300px; background: white;" 
      />
  
      <!-- Botón Guardar -->
      <button @click="saveContent" class="mt-4 px-4 py-2 bg-blue-500 text-white rounded">
        Guardar Mensaje personalizado
      </button>
    </div>
  </template>
  
  <script setup>
  import { ref, defineProps, onMounted } from 'vue'
  import { QuillEditor } from '@vueup/vue-quill'
  
  // Props del padre
  const props = defineProps({
    nombreEvento: String,
    tokenEvento: String
  })
  
  const content = ref('')
  const quillRef = ref(null)
  
  // Lista de variables
  const variablesDisponibles = [
    { clave: '{{NOMBRE_COMPLETO}}' },
    { clave: '{{CORREO_ELECTRONICO}}' },
    { clave: '{{NOMBRE_EVENTO}}' },
    { clave: '{{NOMBRE_GRUPO}}' }
  ]
  
  // Insertar variable donde esté el cursor
  const insertarVariable = (variable) => {
    const editorInstance = quillRef.value?.getQuill?.()
    if (editorInstance) {
        const range = editorInstance.getSelection()
        if (range) {
        editorInstance.insertText(range.index, variable, 'user')
        editorInstance.setSelection(range.index + variable.length)
        }
    } else {
        console.warn('Editor no está listo')
    }
    }

  // Guardar contenido
  const saveContent = async () => {
    try {
      const response = await fetch('/api/mensaje-personalizado', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token_evento: props.tokenEvento,
          nombre_evento: props.nombreEvento,
          contenido_html: content.value
        })
      })
      const data = await response.json()
      alert(data.status)
    } catch (error) {
      alert('Error al guardar: ' + error.message)
    }
  }
  
  // Cargar contenido previo
  onMounted(async () => {
    try {
      const res = await fetch(`/api/mensaje-personalizado/${props.tokenEvento}`);
      const data = await res.json();
      if (data.status === 'ok' && data.data) {
        content.value = data.data.contenido_html;
      }
    } catch (err) {
      console.error('Error al cargar contenido:', err);
    }
    const checkEditor = () => {
        const editor = quillRef.value?.getQuill?.()
        if (!editor) {
        setTimeout(checkEditor, 100) // Espera hasta que esté listo
        }
    }
    checkEditor()
  })
  </script>
  